import tip from "@/utils/tip";
import router from "@/router";
import i18n from "@/lang";

export default {
  parse: (response) => {
    switch (response.retcode) {
      case -2:
      case -3:
        tip.warning({
          message: i18n.t("statusCode["+response["retcode"]+"]"),
          onClose: () => {
            router.push({ name: "login" });
          },
        });
        break;
      case -4:
        router.push({ name: "limit" });
        break;
      case -5:
          tip.warning({
            message: response.message,
          });
          break;
      case -6:
        router.push({ name: "notOpen" ,params: {breadcrumb: response.data}});
        break;
      case -7:
        router.push({ name: "login" ,params: {pmode: true} });
        break;
        // router.push({ name: "maintain" });
      case -8:
      case -9:
        location.href = location.origin + '/web/maintain.php';
        // location.href = location.origin + '/';
        break;
      default:
        tip.error({
          message: response.message,
          showClose: true,
          onClose: () => {
            window.location.href = window.location.origin;
          },
        });
    }

    return Promise.reject(response);
  },
};
